/** 车类别 */
export const CAR_CATEGORY_ENUM = [
  { label: "全部", value: "" },
  {
    value: "铁皮车",
    label: "铁皮车",
  },
  {
    value: "冷藏车",
    label: "冷藏车",
  },
  {
    value: "高栏车",
    label: "高栏车",
  },
];

/** 条件 */
export const CONDITION_ENUM = [
  { label: "全部", value: "" },
  {
    value: 1,
    label: "大于",
  },
  {
    value: 2,
    label: "大于等于",
  },
  {
    value: 3,
    label: "小于",
  },
  {
    value: 4,
    label: "小于等于",
  },
];
